import { render, staticRenderFns } from "./TokenStaging.vue?vue&type=template&id=d5379368&scoped=true"
import script from "./TokenStaging.vue?vue&type=script&lang=js"
export * from "./TokenStaging.vue?vue&type=script&lang=js"
import style0 from "./TokenStaging.vue?vue&type=style&index=0&id=d5379368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5379368",
  null
  
)

export default component.exports